// extracted by mini-css-extract-plugin
export var createUser = "create-user_BWLxC077zAUdg2zXaXim";
export var createUserHeader = "create-user__header_h4OUqAg3aPWe2wDGIA04";
export var createUserTitle = "create-user__title_MpOBxeUOYszLE7DmgEpA";